import { render } from "./mapformmodel.vue?vue&type=template&id=9836735a&scoped=true"
import script from "./mapformmodel.vue?vue&type=script&lang=js"
export * from "./mapformmodel.vue?vue&type=script&lang=js"

import "./mapformmodel.vue?vue&type=style&index=0&id=9836735a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9836735a"]])

export default __exports__